/**
 * 좌우로 움직이는 켬/끔 스위치.
 *
 * <b>체크박스가 아니라 스위치인 자리에만 쓴다.</b> 둘의 차이는 모양이 아니라 뜻이다 — 체크박스는
 * "저장을 누르면 반영될 선택" 이고, 스위치는 <b>누르는 즉시 상태가 바뀌는</b> 것이다. 그래서 이
 * 컴포넌트는 확인 버튼을 두지 않고 `onChange` 를 바로 부른다.
 *
 * 위젯 관리 모달의 AI 인사말 토글과 같은 치수·움직임을 쓴다. 같은 제품 안에서 같은 뜻의 조작이
 * 화면마다 다르게 생기면, 사용자는 그것을 다른 조작으로 배운다.
 */
export function Switch({
  checked,
  onChange,
  label,
  disabled = false,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** 스크린리더가 읽을 이름. 옆의 글자와 같은 말이어야 한다. */
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className="flex-shrink-0 rounded-full"
      style={{
        width: '32px',
        height: '18px',
        padding: '2px',
        border: '1px solid var(--border-strong)',
        background: checked ? 'var(--accent)' : 'var(--border)',
        // 저장 중에는 두 번 눌리지 않게 막되, 흐려 보이게만 하고 자리는 그대로 둔다.
        opacity: disabled ? 0.6 : 1,
        transition: 'background 150ms',
      }}
    >
      <span
        className="block rounded-full"
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          transform: checked ? 'translateX(14px)' : 'translateX(0)',
          transition: 'transform 150ms',
        }}
      />
    </button>
  );
}
